import styled from 'styled-components'
import { Stack } from '@mui/material'

export const Container = styled(Stack)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
`
